import type { CustomFieldDefinition } from '@fukuri-admins/apis/client/gen/model';
import { match } from 'ts-pattern';

/**
 * 定義の input_type / value_type に応じて表示用文字列を返す
 *
 * @param definition カスタムフィールド定義
 * @param value 値（文字列）
 * @returns 表示用文字列
 */
export const getDisplayValue = (definition: CustomFieldDefinition, value: string): string =>
  match(definition.input_type)
    .with('choice', () => getChoiceValue(definition, value))
    .with('multi_choice', () =>
      value
        .split(',')
        .map(v => getChoiceValue(definition, v))
        .join(', ')
    )
    .with('plain', () => (definition.value_type === 'bool' ? getBoolDisplayValue(value) : value))
    .exhaustive();

const getBoolDisplayValue = (value: string): string =>
  match(value)
    .with('true', () => 'はい')
    .with('false', () => 'いいえ')
    .otherwise(() => value);

const getChoiceValue = (definition: CustomFieldDefinition, value: string): string => {
  const options = definition.options;
  if (!options || typeof options[value] !== 'string') return value;
  return options[value] as string;
};
